/**
 * Utility functions for the EventsTimeline component.
 */

/**
 * Decode HTML entities in text.
 * @example decodeHtmlEntities("&amp;") // returns "&"
 */
export function decodeHtmlEntities(text: string): string {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
}

/**
 * Extract email address from text like "Melike Kozan <melike@ajww.com>".
 * Returns the email portion, or the original text if no email found.
 */
export function extractEmail(text: string): string {
  const match = text.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/);
  return match ? match[0] : text;
}
